export default {
  zh: {
    plaza: 'CP',
    rank: '排行榜',
    reward: '奖励',
    week: '本周排行',
    title: 'CP互相赠送礼物（超过1800金币）会展示在cp广场',
    last: '上周排行',
    previous: '以往CP第一名',
    remark: '发送礼物"求婚",就可以成为cp,只有互相赠送cp礼物才会增加cp积分',
    cp: '是否取消CP（取消后所有积分清零）',
    cancel: '取消',
    confirm: '确定',
    clear: '取消',
    totalScore: '总积分（不仅是这周）',
    service: '如果有疑问，点击这里联系客服',
    rewardtitle: '规则',
    days: 'days',
    rewardRule: `
    - 关于头像框和座驾：可以从用户获胜的任何位置拿走头像框和座驾<br/><br/>
    - 关于徽章：徽章只能在完成用户获胜中心的积分的情况下获得，不能兑换其他中心的任何徽章<br/><br/>
    - 关于金币：如果用户赢了其中一个名次，比如（某用户赢了第一名，但是他的积分只有500k，意味着小于800k。在这种情况下，他将获得第一名头像框+第一名座驾+第一名徽章+第二名的金币，因为他满足了超过400k的第二名的金币条件）<br/><br/>
    但是如果第一名的积分小于500k，比如只有400k，那意味着比获得第一名的徽章的条件还低，在这种情况下，他将只获得第一名的头像框和座驾，没有徽章奖励。
    <br/>其他礼物不会影响您的CP分数，只有CP礼物可以提高您的活动分数`,
    yy: '为了庆祝情人节，在活动期间,赠送情人节特别礼物（ run to you），也可以成为cp，这周前三名将会有额外奖励，祝大家情人节快乐 。'
  },
  ar: {
    plaza: 'CP',
    rank: ' التصنيف',
    reward: 'الجوائز',
    mycp: 'My CP',
    showDay: 'Show *7 days',
    mountDay: 'Mount *7 days',
    medalDay: 'Medal *7 days',
    vipDay: 'VIP4 *7 days',
    backgriundDay: 'Background *7 days',
    headDay: 'Head *7 days',
    headDays: 'Head *7 days',
    goldScore: '25K(score>800K)',
    top2Gold: '15K(scroe>400K)',
    top3Gold: '5K(score>250K)',
    week: 'الترتيب هذا الأسبوع',
    title: 'سيتم عرض هدايا التبادل CP (عملة أكثر من 1800 عملة) في CP Plaza',
    last: 'الأسبوع الماضي',
    previous: 'رقم 1 السابق CP',
    remark:
      'أرسل هدية "عرض الزواج" لتصبح سى بى. أى هدية يقدمها السى بى لبعضكما ستزيد من قيمة السى بى.يمكنك المشاركة في الحدث من خلال هداياء CP<br/>لا يمكن للهدايا الأخرى التأثير على درجة CP ، فقط هداياء CP يمكنها رفع درجة النشاط ',
    cp: 'ما إذا كان سيتم إلغاء علاقة CP (بعد الإلغاء ، ستصبح جميع درجاتك 0)',
    cancel: 'يلغي',
    confirm: 'نعم',
    clear: 'يلغي',
    totalScore: 'مجموع النقاط (ليس هذا الأسبوع فقط)',
    service: 'إذا كانت لديك اي مشكله  ، يرجى النقر هنا للتواصل مع خدمة العملاء أحلام ',
    rewardtitle: 'حكم',
    since: 'Since',
    days: 'أيام',
    showNewske: 'وظيفة CP في عملية التصميم',
    rewardRule: `
- بخصوص الاطار و السيارة : يمكن اخد غطاء راس و سيارة اي مركز فاز فيه المستخدم <br/><br/>
- بخصوص الشارة : لا يمكن اخد الشارة الا في حالة اكمال نقاط المركز الذي فاز فيه المستخدم و لا يمكن استبدالها باي شاره اخرى لباقي المراكز <br/><br/>
- بخصوص الكونزات : في حالة فوز المستخدم باحد المراكز على سبيل المثال ( فاز مستخدم بالمركز الاول لكن نقاطه  مثلا 005k يعني اقل من 008k التي هي متطلبات الحصول على كونزات في هذه الحاله سياخد اطار المركز الاول + سيارة المركز الاول + شارة المركز الاول + و يمكنه الحصول على كونزات المركز الثاني لانه حقق شرط كونزات المركز الثاني الذي هو اكثر من 004k ) <br/><br/>
لكن في حالة كان فائز في المركز الاول بنقاط اقل من 005k مثلا 004k يعني اقل حتى من نقاط الشارة الاولى في هذه الحالة سياخد الاطار و السيارة للمركز الاول و كونزات المركز الثاني فقط يعني مكافئات بدون شارة 
<br/>-يمكنك المشاركة في الحدث من خلال هداياء CP<br/>-لا يمكن للهدايا الأخرى التأثير على درجة CP ، فقط هداياء CP يمكنها رفع درجة النشاط     `,
    yy: `
    من أجل الاحتفال بعيد الحب، خلال الاحتفال ، أرسل هدية (run to you) ، يمكن أيضًا أن تصبحوا cp. سيحصل الفائزون الثلاثة الأوائل هذا الأسبوع أيضًا على أشياء جيدة إضافية. تحيات عيد الحب!
    `
  },
  en: {
    plaza: 'CP',
    rank: 'Rank',
    reward: 'Reward',
    showDay: 'Show *7 days',
    mountDay: 'Mount *7 days',
    medalDay: 'Medal *7 days',
    vipDay: 'VIP4 *7 days',
    vip2Day: 'Vip2 - 7Gün',
    vip3Day: 'Vip3 - 7Gün',
    showNewske: 'CP function development in progress',
    backgriundDay: 'Background *7 days',
    headDay: 'Head *7 days',
    headDays: 'Head *7 days',
    goldScore: '25K(score>800K)',
    top2Gold: '15K(scroe>400K)',
    top3Gold: '5K(score>250K)',
    mycp: 'My CP',
    week: 'Ranking this week',
    title: 'CP exchange gifts(coin more then 1800 coin) Will be displayed at CP Plaza', //
    last: 'CP Last Week',
    previous: 'Previous No.1 CP',
    remark:
      'Send a "marriage proposal" gift to become a CP. You can participate in the event through CP gifts<br/>Other gifts will not affect the CP rating, only CP gifts can improve the event rating',
    cp: 'Whether to cancel the CP relationship (after cancellation, all your scores will become 0)',
    cancel: 'No',
    confirm: 'Yes',
    since: 'Since',
    clear: 'Cancel',
    totalScore: 'Total Score (Not only this week)',
    service: 'If you have questions, please click here to contact customer service.',
    rewardtitle: 'Rules',
    days: 'days',
    rewardRule: `
    - Regarding the headwear and the car : You can take a headwear and a car, whichever position the user won.<br/><br/>
    - Regarding the badge: The badge can only be taken in the case of completing the points of the position in which the user won, and it cannot be exchanged for any other badge for the rest of the centers.<br/><br/>
    - Regarding the coins: in the event that the user wins one of the centers, for example (a user won the first place, but his points, for example, 500k, means less than 800k, which are the requirements to obtain coins, in this case he will take the first place headwear + the first place car + the first place badge + and he can get  for second-place coins because he met the condition for second-place coins, which is more than 400k).<br/><br/>
    But in the event that he was a winner in the first place with less than 500k points, for example, 400k means less even than the points of the first badge , In this case, he will take the headwear and the car for the first place and the second place coins only, which means rewards without a badge.
    <br/>Other gifts will not affect your CP score, only CP gifts can improve your activity score`,
    yy: `In order to celebrate Valentine's Day, during the event, send  gift(run to you) , can also become cp, The top three of this week will have additional rewards.happy Valentine's Day!`
  },
  tr: {
    days: 'gün',
    plaza: 'CP',
    rank: 'Sıralama',
    showNewske: 'CP alanı gelişimi devam ediyor',
    showDay: '7Gün Gösterilir',
    mountDay: 'Özel Hediye 7Gün',
    medalDay: 'Madalya 7Gün',
    vipDay: 'Vip4 - 7Gün',
    vip2Day: 'Vip2 - 7Gün',
    vip3Day: 'Vip3 - 7Gün',
    backgriundDay: 'Tema 7Gün',
    headDay: 'Çerçeve 7Gün',
    headDays: 'Çerçeve 7Gün',
    goldScore: '25K (800k Üstü)',
    top2Gold: '15K (400k Üstü)',
    top3Gold: '5K (250k Üstü)',
    reward: 'Ödüller',
    week: 'Bu Hafta Sıralama',
    mycp: 'Benim Cp’m',
    title: "CP hediyeleri (1.800 Coins ve üzeri atılan hediyeler) CP Alanın'da sergilenecek.", //
    last: 'Geçen Hafta',
    previous: 'Diğer Hafta 1’ler',
    since: 'Tarihler Arası',
    remark:
      '"Cp Teklifi" hediyesi atarak Cp oluşturabilirsiniz. Sadece Cp hediyeleri atarak sıralamaya katılabilirsiniz diğer hediyeler puan kazandırmaz.',
    cp: 'Whether to cancel the CP relationship (after cancellation, all your scores will become 0)',
    cancel: 'No',
    confirm: 'Yes',
    clear: 'Ayrıl',
    totalScore: 'Toplam Puan( Haftalık Değil )',
    service: 'Sorularınız var ise, lütfen Müşteri hizmetleri ile iletişime geçmek için buraya tıklayın.',
    rewardtitle: 'Kurallar',
    rewardRule: `
    - Çerçeve ve Araç: Kullanıcı hangi Sıralamayı kazanırsa kazansın, bir çerçeve ve bir Araç alabilir.<br/><br/>
    - Rozet: Rozet, Yalnızca kullanıcının kazandığı sıralamanın puanlarının tamamlanması durumunda alınabilir ve başka bir rozetle değiştirilemez.<br/><br/>
    - Altın Desteği: Kullanıcının sıralamadan birini kazanması durumunda, örneğin (bir kullanıcı ilk sırayı kazandı, ancak puanları, örneğin 500K, Altın desteği almak için gereken 800K’dan az anlamına gelir, bu durumda birincilik Çerçevesi + birincilik Araç + birincilik rozeti + 400 binden fazla olan ikinci sıra Altın desteği koşulunu karşıladığı için ikincilik ödülleri alabilir).<br/><br/>
    Ancak ilk sırada 500K daha az puanla birinci olması durumunda, örneğin 400K, ilk rozetin puanlarından bile daha az anlamına gelir, bu durumda, sadece birincilik ve ikincilik için çerçeveyi ve Araç alacak, bu da rozetsiz ödüller anlamına gelir.
    <br/>Diğer hediyeler CP puanınızı etkilemez, yalnızca CP hediyeleri Cp Etkinliği puanınızı artırabilir.`,
    yy: `In order to celebrate Valentine's Day, during the event, send  gift(run to you) , can also become cp, The top three of this week will have additional rewards.happy Valentine's Day!`
  },
  pt: {
    plaza: 'CP',
    rank: 'Classificação',
    reward: 'Recompensa',
    showDay: 'Mostrar *7 dias',
    mountDay: 'Montar *7 dias',
    medalDay: 'Medalha *7 dias',
    vipDay: 'VIP4 *7 dias',
    vip2Day: 'Vip2 - 7Dias',
    vip3Day: 'Vip3 - 7Dias',
    showNewske: 'Função CP em desenvolvimento',
    backgriundDay: 'Fundo *7 dias',
    headDay: 'Cabeça *7 dias',
    headDays: 'Cabeça *7 dias',
    goldScore: '25K(pontos>800K)',
    top2Gold: '15K(pontos>400K)',
    top3Gold: '5K(pontos>250K)',
    mycp: 'Meu CP',
    week: 'Classificação desta semana',
    title: 'Troca de presentes CP (moeda mais que 1800 moedas) será exibida no CP Plaza',
    last: 'CP da semana passada',
    previous: 'Anterior CP No.1',
    remark:
      'Envie um presente de "pedido de casamento" para se tornar um CP. Você pode participar do evento por meio de presentes CP<br/>Outros presentes não afetarão a classificação CP, apenas os presentes CP podem melhorar a classificação do evento',
    cp: 'Deseja cancelar o relacionamento CP (após o cancelamento, todos os seus pontos se tornarão 0)?',
    cancel: 'Não',
    confirm: 'Sim',
    since: 'Desde',
    clear: 'Cancelar',
    totalScore: 'Pontuação total (Não apenas esta semana)',
    service: 'Se você tiver dúvidas, clique aqui para contatar o atendimento ao cliente.',
    rewardtitle: 'Regras',
    days: 'dias',
    rewardRule: `
    - Sobre os acessórios e o carro: Você pode pegar um acessório e um carro, qualquer que seja a posição que o usuário tenha vencido.<br/><br/>
    - Sobre o emblema: O emblema só pode ser obtido caso o usuário complete os pontos da posição em que venceu, e não pode ser trocado por qualquer outro emblema dos outros centros.<br/><br/>
    - Sobre as moedas: caso o usuário vença em um dos centros, por exemplo (um usuário venceu o primeiro lugar, mas seus pontos, por exemplo, 500k, são inferiores a 800k, que são os requisitos para obter moedas, neste caso ele pegará o acessório do primeiro lugar + o carro do primeiro lugar + o emblema do primeiro lugar + ele poderá pegar as moedas do segundo lugar porque atingiu a condição das moedas do segundo lugar, que é mais de 400k).<br/><br/>
    Mas caso ele tenha vencido o primeiro lugar com menos de 500k pontos, por exemplo, 400k, que é até inferior aos pontos do primeiro emblema, neste caso ele pegará o acessório e o carro do primeiro lugar e apenas as moedas do segundo lugar, o que significa recompensas sem emblema.
    <br/>Outros presentes não afetarão sua pontuação CP, apenas os presentes CP podem melhorar sua pontuação de atividade.`,
    yy: `Para celebrar o Dia dos Namorados, durante o evento, envie um presente (corre para você), também pode se tornar CP. Os três primeiros desta semana terão recompensas adicionais. Feliz Dia dos Namorados!`
  },
  id: {
    plaza: 'CP',
    rank: 'Peringkat',
    reward: 'Hadiah',
    showDay: 'Tampilkan *7 hari',
    mountDay: 'Mount *7 hari',
    medalDay: 'Medali *7 hari',
    vipDay: 'VIP4 *7 hari',
    vip2Day: 'Vip2 - 7Hari',
    vip3Day: 'Vip3 - 7Hari',
    showNewske: 'Pengembangan fungsi CP sedang berlangsung',
    backgriundDay: 'Latar belakang *7 hari',
    headDay: 'Kepala *7 hari',
    headDays: 'Kepala *7 hari',
    goldScore: '25K(skor>800K)',
    top2Gold: '15K(skor>400K)',
    top3Gold: '5K(skor>250K)',
    mycp: 'CP Saya',
    week: 'Peringkat minggu ini',
    title: 'Hadiah tukar CP(coin lebih dari 1800 coin) Akan ditampilkan di Plaza CP',
    last: 'CP Minggu Lalu',
    previous: 'CP No.1 Sebelumnya',
    remark:
      'Kirim hadiah "lamaran pernikahan" untuk menjadi CP. Anda dapat berpartisipasi dalam acara melalui hadiah CP<br/>Hadiah lain tidak akan mempengaruhi peringkat CP, hanya hadiah CP yang dapat meningkatkan peringkat acara',
    cp: 'Apakah Anda ingin membatalkan hubungan CP (setelah pembatalan, semua skor Anda akan menjadi 0)',
    cancel: 'Tidak',
    confirm: 'Ya',
    since: 'Sejak',
    clear: 'Batalkan',
    totalScore: 'Total Skor (Tidak hanya minggu ini)',
    service: 'Jika Anda memiliki pertanyaan, klik di sini untuk menghubungi layanan pelanggan.',
    rewardtitle: 'Aturan',
    days: 'hari',
    rewardRule: `
    - Mengenai penutup kepala dan mobil: Anda dapat mengambil penutup kepala dan mobil, apapun posisi yang dimenangkan oleh pengguna.<br/><br/>
    - Mengenai lencana: Lencana hanya dapat diambil jika memenuhi poin dari posisi yang dimenangkan oleh pengguna, dan tidak dapat ditukar dengan lencana lain untuk sisa pusat.<br/><br/>
    - Mengenai koin: jika pengguna memenangkan salah satu pusat, misalnya (seorang pengguna memenangkan tempat pertama, tetapi skornya, misalnya 500k, berarti kurang dari 800k, yang merupakan persyaratan untuk mendapatkan koin, dalam hal ini ia akan mendapatkan penutup kepala tempat pertama + mobil tempat pertama + lencana tempat pertama + dan ia bisa mendapatkan koin tempat kedua karena ia memenuhi kondisi koin tempat kedua, yaitu lebih dari 400k).<br/><br/>
    Namun, jika ia memenangkan tempat pertama dengan skor kurang dari 500k, misalnya 400k yang berarti lebih rendah dari skor lencana pertama, dalam hal ini ia hanya akan mendapatkan penutup kepala dan mobil untuk tempat pertama dan koin tempat kedua saja, yang berarti hadiah tanpa lencana.
    <br/>Hadiah lain tidak akan mempengaruhi skor CP Anda, hanya hadiah CP yang dapat meningkatkan skor aktivitas Anda`,
    yy: `Untuk merayakan Hari Valentine, selama acara, kirim hadiah (berlari ke Anda), juga dapat menjadi CP, Tiga besar minggu ini akan mendapatkan hadiah tambahan. Selamat Hari Valentine!`
  },
  uz: {
    plaza: 'CP',
    rank: 'Reyting',
    reward: 'Mukofot',
    showDay: "Ko'rsatish *7 kun",
    mountDay: 'Qurish *7 kun',
    medalDay: 'Medal *7 kun',
    vipDay: 'VIP4 *7 kun',
    vip2Day: 'Vip2 - 7Kun',
    vip3Day: 'Vip3 - 7Kun',
    showNewske: 'CP funksiyasi rivojlanmoqda',
    backgriundDay: 'Orqa fon *7 kun',
    headDay: 'Bosh *7 kun',
    headDays: 'Bosh *7 kun',
    goldScore: '25K(ball>800K)',
    top2Gold: '15K(ball>400K)',
    top3Gold: '5K(ball>250K)',
    mycp: 'Mening CP',
    week: 'Bu haftaning reytingi',
    title: "CP almashish sovg'alarini (coin 1800 coin dan ortiq) CP Plaza-da ko'rsatish",
    last: "CP O'tgan hafta",
    previous: 'Oldingi No.1 CP',
    remark:
      "CP bo'lish uchun 'turmushga taklif' sovg'asi yuboring. Siz CP sovg'alari orqali tadbirga qatnashishingiz mumkin.<br/>Boshqa sovg'alar CP reytingiga ta'sir qilmaydi, faqat CP sovg'alari tadbir reytingini oshirishi mumkin.",
    cp: "CP munosabatini bekor qilishni xohlaysizmi (bekor qilgandan so'ng, barcha ballaringiz 0 bo'ladi)",
    cancel: "Yo'q",
    confirm: 'Ha',
    since: 'Beri',
    clear: 'Bekor qilish',
    totalScore: 'Jami ball (faqat bu hafta emas)',
    service: "Savollaringiz bo'lsa, iltimos, mijozlarga xizmat ko'rsatish bilan bog'lanish uchun shu yerni bosing.",
    rewardtitle: 'Qoidalar',
    days: 'kun',
    rewardRule: `
    - Bosh kiyim va mashina haqida: Foydalanuvchi yutgan pozitsiyasiga qarab, bosh kiyim va mashina olish mumkin.<br/><br/>
    - Medalyoni haqida: Medalyon faqat foydalanuvchi yutgan pozitsiya ballari to'liq bo'lsa, olinadi va boshqa markazlar uchun medalyonlar almashtirilmaydi.<br/><br/>
    - Tanga haqida: Foydalanuvchi biror markazni yutgan taqdirda, masalan (foydalanuvchi birinchi o'rinni yutgan bo'lsa, ammo uning ballari 500k, ya'ni 800k dan kam bo'lsa, bu tangalarni olish talablariga javob bermasa, u birinchi o'rin bosh kiyimi + birinchi o'rin mashinasi + birinchi o'rin medali + ikkinchi o'rin tangalarini olishi mumkin, chunki u ikkinchi o'rin tangalarini olish uchun talabni qondirdi, bu 400k dan yuqori).<br/><br/>
    Ammo agar u birinchi o'rinda 500k ballardan kam bo'lsa, masalan, 400k, bu birinchi medalyon ballaridan ham kam, bu holatda u faqat birinchi o'rin bosh kiyimi va mashinasini oladi, ikkinchi o'rin tangalarini oladi, ya'ni medalyonsiz mukofotlar.`,
    yy: "Sevishganlar kunini nishonlash uchun, tadbir davomida sovg'a yuboring (sizga yugurib keladi), shuningdek CP bo'lish mumkin, bu haftaning eng yaxshi uchligi qo'shimcha mukofotlarga ega bo'ladi. Sevishganlar kuningiz muborak!"
  },
  ru: {
    plaza: 'CP',
    rank: 'Рейтинг',
    reward: 'Награда',
    showDay: 'Показать *7 дней',
    mountDay: 'Монтаж *7 дней',
    medalDay: 'Медаль *7 дней',
    vipDay: 'VIP4 *7 дней',
    vip2Day: 'Vip2 - 7Дней',
    vip3Day: 'Vip3 - 7Дней',
    showNewske: 'Разработка функции CP в процессе',
    backgriundDay: 'Фон *7 дней',
    headDay: 'Голова *7 дней',
    headDays: 'Голова *7 дней',
    goldScore: '25K(баллы>800K)',
    top2Gold: '15K(баллы>400K)',
    top3Gold: '5K(баллы>250K)',
    mycp: 'Мой CP',
    week: 'Рейтинг на этой неделе',
    title: 'Обмен CP подарками (монеты более 1800 монет) будет отображаться в CP Plaza',
    last: 'CP Последняя неделя',
    previous: 'Предыдущий No.1 CP',
    remark:
      "Отправьте подарок 'предложение руки и сердца', чтобы стать CP. Вы можете участвовать в событии через CP подарки.<br/>Другие подарки не повлияют на рейтинг CP, только CP подарки могут улучшить рейтинг события.",
    cp: 'Хотите ли вы отменить отношения CP (после отмены все ваши баллы станут 0)?',
    cancel: 'Нет',
    confirm: 'Да',
    since: 'С',
    clear: 'Отменить',
    totalScore: 'Общий балл (не только на этой неделе)',
    service: 'Если у вас есть вопросы, пожалуйста, нажмите здесь, чтобы связаться с службой поддержки.',
    rewardtitle: 'Правила',
    days: 'дней',
    rewardRule: `
    - О головных уборах и машинах: Вы можете получить головной убор и машину, в зависимости от того, на какой позиции выиграл пользователь.<br/><br/>
    - О медалях: Медаль можно получить только в том случае, если баллы позиции, на которой выиграл пользователь, выполнены, и она не может быть обменена на другие медали в других центрах.<br/><br/>
    - О монетах: Если пользователь выигрывает в одном из центров, например (пользователь выиграл первое место, но его баллы, например, 500k, меньше 800k, что является требованием для получения монет, в этом случае он получит головной убор первого места + машину первого места + медаль первого места + и сможет получить монеты второго места, так как выполнил условие для монет второго места, что больше 400k).<br/><br/>
    Однако если он стал победителем первого места с баллами менее 500k, например, 400k, что даже меньше баллов первой медали, то он получит только головной убор и машину первого места и монеты второго места, что означает награды без медали.`,
    yy: 'В честь Дня Святого Валентина, во время события отправьте подарок (побежит к вам), также можно стать CP. Топ-3 этой недели получат дополнительные награды. Счастливого Дня Святого Валентина!'
  },
  fa: {
    plaza: 'CP',
    rank: 'رتبه',
    reward: 'جایزه',
    showDay: 'نمایش *7 روز',
    mountDay: 'نصب *7 روز',
    medalDay: 'مدال *7 روز',
    vipDay: 'VIP4 *7 روز',
    vip2Day: 'Vip2 - 7روز',
    vip3Day: 'Vip3 - 7روز',
    showNewske: 'توسعه عملکرد CP در حال پیشرفت است',
    backgriundDay: 'پس‌زمینه *7 روز',
    headDay: 'سر *7 روز',
    headDays: 'سر *7 روز',
    goldScore: '25K(امتیاز>800K)',
    top2Gold: '15K(امتیاز>400K)',
    top3Gold: '5K(امتیاز>250K)',
    mycp: 'CP من',
    week: 'رتبه‌بندی این هفته',
    title: 'هدایای تبادل CP (سکه‌های بیشتر از 1800 سکه) در CP Plaza نمایش داده خواهد شد',
    last: 'CP هفته گذشته',
    previous: 'CP شماره 1 قبلی',
    remark:
      "برای CP شدن، یک هدیه 'پیشنهاد ازدواج' ارسال کنید. شما می‌توانید از طریق هدایای CP در رویداد شرکت کنید.<br/>هدایای دیگر تاثیری بر رتبه‌بندی CP ندارند و فقط هدایای CP می‌توانند امتیاز رویداد را بهبود بخشند.",
    cp: 'آیا می‌خواهید رابطه CP را لغو کنید؟ (پس از لغو، تمام امتیازهای شما به 0 تبدیل می‌شود)',
    cancel: 'خیر',
    confirm: 'بله',
    since: 'از',
    clear: 'لغو',
    totalScore: 'امتیاز کل (فقط این هفته نیست)',
    service: 'اگر سوالی دارید، لطفاً اینجا کلیک کنید تا با پشتیبانی مشتری تماس بگیرید.',
    rewardtitle: 'قوانین',
    days: 'روز',
    rewardRule: `
    - در مورد کلاه‌گیس و ماشین: شما می‌توانید کلاه‌گیس و ماشین را بگیرید، بسته به پوزیشن برنده‌شده توسط کاربر.<br/><br/>
    - در مورد مدال: مدال فقط در صورتی قابل دریافت است که امتیازات موقعیت برنده‌شده توسط کاربر تکمیل شود و نمی‌توان آن را برای هیچ مدال دیگری در سایر مراکز تعویض کرد.<br/><br/>
    - در مورد سکه‌ها: در صورتی که کاربر یکی از مراکز را برنده شود، مثلاً (یک کاربر اولین جایزه را برد، اما امتیاز او، به عنوان مثال، 500k است، که کمتر از 800k است که برای دریافت سکه‌ها لازم است، در این صورت او کلاه‌گیس و ماشین اولین جایزه + مدال اولین جایزه را خواهد گرفت و می‌تواند سکه‌های جایزه دوم را دریافت کند زیرا شرایط دریافت سکه‌های جایزه دوم که بیشتر از 400k است را دارد).<br/><br/>
    اما اگر او در اولین جایزه با امتیاز کمتر از 500k، به عنوان مثال 400k برنده شود، این امتیاز حتی کمتر از امتیاز اولین مدال است، در این صورت او فقط کلاه‌گیس و ماشین اولین جایزه و سکه‌های جایزه دوم را خواهد گرفت، که به این معنی است که جوایز بدون مدال است.`,
    yy: 'به مناسبت روز ولنتاین، در طول رویداد، یک هدیه ارسال کنید (برای شما می‌دود)، همچنین می‌توانید CP شوید. سه نفر برتر این هفته جوایز اضافی خواهند داشت. روز ولنتاین مبارک!'
  }
}



// WEBPACK FOOTER //
// src/pages/activity/couples/lang.js